import React, { FC, useEffect, useState } from 'react';
import {
  EditButton,
  ShowButton,
  useDataProvider,
  useNotify,
  usePermissions,
} from 'react-admin';
import {
  Box,
  Button,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import DialogContent from '@material-ui/core/DialogContent';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Dialog from '@material-ui/core/Dialog';

import { getFieldByTitle } from '../../helpers/sortByTitle';
import { User } from '../../types/user';
import UsersListTittle from '../common/listTitles/UsersListTitle';
import HeadTable from '../common/sortTable/sortTable';
import PaginationTable from '../common/paginationTable';
import DiscountFilter from '../fixedOdds/DiscountFilter';
import RemoveItem from '../common/Remove/RemoveItem';
import TablesSearch from '../common/tablesSearch/tablesSearch';
import { checkPermission } from '../../helpers/checkPermissions';
import Loader from '../common/loader';

// import './index.css';

const SubscriptionsStatisticsTable = (props) => {
  const [loading, setLoading] = useState(false);
  const { permissions } = usePermissions();
  const dataProvider = useDataProvider();
  const notify = useNotify();

  useEffect(() => {
    getStatistics();
  }, []);

  const [state, setState] = useState({
    statistics: {},
    prices: [],
    rows: [],
    headers: [],
  });

  const getStatistics = async () => {
    try {
      setLoading(true);
      const statistics = (await dataProvider.getSubscriptionStatistics(
        props.type
      )) as any;
      setState({
        ...state,
        statistics: statistics.data.statistics,
        prices: statistics.data.prices,
        rows: statistics.data.rows,
        headers: statistics.data.headers,
      });
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  const handleUpdateToRows = () => {
    let rows = Object.keys(state.statistics).map((key, index) => {
      let counts = state.prices.map((price, index) => {
        return state.statistics[key][price];
      });
      return {
        status: key,
        counts: counts,
        // firstCount: state.statistics[key][state.statistics[key]],
        // secondCount: state.statistics[key][2500],
      };
    });
    return rows;
  };
  const handleStatus = (status: string) => {
    switch (status) {
      case 'ACTIVE': {
        return status;
      }
      case 'PAUSED': {
        return status;
      }
      case 'CANCELLED': {
        return status;
      }
      case 'MONTHLY_CANCELLED': {
        return 'CANCELLED';
      }
      case 'MONTHLY_CANCELLED_FINISHED': {
        return 'CANCELLED';
      }
      case 'FINISHED': {
        return 'MONTHLY PAYMENT FAILED';
      }
    }
  };

  return (
    <Box marginTop='0.5em' marginBottom='40px'>
      <TableContainer>
        {/* <Table>
          <TableHead>
            <TableRow>
              <TableCell id='status-table-head-actions'>Status</TableCell>
              {state.prices.map((price, index) => {
                return (
                  <TableCell
                    key={index}
                    id='status-table-head-actions'
                    align='center'
                  >
                    {`£ ${price / 100}`}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          {handleUpdateToRows().map((item) => {
            return (
              <TableBody key={item.status}>
                <TableRow>
                  <TableCell>{handleStatus(item.status)}</TableCell>
                  {item.counts.map((count, index) => {
                    return (
                      <TableCell key={index + count} align='center'>
                        {count}
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableBody>
            );
          })}
        </Table> */}
        {loading ? (
          <Loader small loading={loading} />
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                {state.headers.map((header, index) => {
                  return (
                    <TableCell
                      key={index}
                      id='status-table-head-actions'
                      align='center'
                    >
                      {header}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            {state.rows.map((row: any) => {
              return (
                <TableBody key={row.status}>
                  <TableRow>
                    <TableCell>{handleStatus(row.status)}</TableCell>
                    {row.list.map((count, index) => {
                      return (
                        <TableCell key={index + count} align='center'>
                          {count}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableBody>
              );
            })}
          </Table>
        )}
      </TableContainer>
    </Box>
  );
};

export default SubscriptionsStatisticsTable;
